export default __webpack_public_path__ + "static/ardha-9342738466211d9591c9e2aae96eee77.svg";